module.exports = __webpack_public_path__ + "img/sym3.f55bb138.png";